export const PERMISSION_SECTIONS = [
  { type: 'role', label: 'Roles', nameHeader: 'Role Name' },
  { type: 'department', label: 'Departments', nameHeader: 'Department' },
  { type: 'privilege', label: 'Privileges', nameHeader: 'Name' },
] as const;

export type PermissionSection = (typeof PERMISSION_SECTIONS)[number];
